<section role="dialog" aria-modal="true" aria-labelledby="email-selection-title"
  class="sm:min-h-[33rem] min-h-[60rem] py-[3rem] gap-[2rem] sm:w-[50rem] w-[70rem] flex flex-col items-center justify-center bg-white">
  <h2 mat-dialog-title id="email-selection-title" class="!min-h-fit">
    {{'TOKEN_USER_SELECTION_LABEL' | translate}}
  </h2>

  <mat-dialog-content class="">
    <div class="!max-h-none !w-full !m-0 !p-0 flex flex-col sm:gap-[5rem] gap-[7rem] items-center justify-center !h-full">
      <div class="flex flex-col sm:w-[40rem] gap-[2rem]">
        <legend class="sr-only">Email selection</legend>
        <p class="dsr-typescale-body-small my-0 text-center">{{'EMAIL_SELECTION_DESCRIPTION' | translate}}</p>
        <div class="w-full">
          @if(data.offer === 'cert') {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'SELECT_USER_EMAIL_LABEL' | translate}}</mat-label>
              <mat-select id="email-select" [(ngModel)]="selectedUser" required aria-required="true"
                [placeholder]="'SELECT_EMAIL_PLACEHOLDER' | translate">
                @for (user of data.userData; track user) {
                  <mat-option [value]="user" [disabled]="user.ptokenBought">{{user.userMail}}</mat-option>
                }
              </mat-select>
              <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black" class="pointer-events-none"
                aria-hidden="true"></dsr-icon>
            </mat-form-field>
          }
          @if(data.offer === 'vci') {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{'SELECT_USER_EMAIL_LABEL' | translate}}</mat-label>
              <mat-select id="email-select" [(ngModel)]="selectedUser" required aria-required="true"
                [placeholder]="'SELECT_EMAIL_PLACEHOLDER' | translate">
                @for (user of data.userData; track user) {
                  <mat-option [value]="user" [disabled]="user.vciModuleBought || user.vciRequested">{{user.userMail}}</mat-option>
                }
              </mat-select>
              <dsr-icon matSuffix name="arrow-down-2" size="1.6rem" color="black" class="pointer-events-none"
                aria-hidden="true"></dsr-icon>
            </mat-form-field>
          }
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions role="group" aria-label="Email selection actions" class="">
    <button mat-flat-button class="" (click)="confirmSelection()" [disabled]="!selectedUser" type="button">
      <span class="">{{'CONFIRM_BUTTON' | translate}}</span></button>
    <button mat-stroked-button color="primary" class="" (click)="closeDialog()" type="button"
      aria-label="Cancel email selection">
      <span class="">{{'CANCEL_BUTTON' | translate}}</span></button>
  </mat-dialog-actions>

</section>
